<template>
  <div class="single-post-200 col-12 position-relative">
    <m-single-content-wrapper @content="dataReady" :content-link="contentLink">
      <template v-slot="{content}">
        <div class="row">

          <div class="col-lg-9 p-0 border bg-white shadow  content-box ">
            <div class="container col-12 p-0 text-dark single-post-200-content ">
              <m-img :alt="content.title" :src="content.thumbnail"
                     class="single-post-200-image  w-100  "/>
              <div class="bottom-right m-4" v-for="category in content.category">
                             <span class="bg-primary p-1 rounded-lg">
                                <m-a class="text-dark" :href="{name:'Posts',query:{category:category.slug}}">
                                    {{ category.name }}
                                </m-a>
                             </span>
              </div>
            </div>
            <h4 class="mr-2 my-4 d-inline-block title-content">{{ content.title }}</h4>
            <div class="row mb-4 justify-content-between mx-auto">
              <div class="mx-3">
                {{ authorName(content) }}
              </div>
              <div class="mx-3">
                {{ dateFormat(content.created_at) }}
              </div>
            </div>
            <p class="p-3" v-html="processContent(content.body)"></p>
          </div>
          <div class="col-lg-3">
            <slot name="p-1"></slot>

            <div class="my-sm-4 my-md-4 my-lg-0 my-4  ">
              <m-category-panel301 :flat-categories-shape="flatCategoriesShape"
                                   class=" category-custom-z-index"/>
            </div>


            <div>
              <h3 v-t="`post.single.related_posts`"></h3>
              <m-single-post-related300 :slicer="3" item-class="col-lg-12 my-2 p-0 mx-0"
                                        :content-category="getContentCategories(content)"
                                        :post-card="relatedPostCard"
                                        :ignore-item="[content.id]"
                                        :content="content"/>
            </div>
            <slot name="p-2"></slot>
          </div>
        </div>
        <div class="col-12">
          <slot name="p-3"></slot>
        </div>
        <div class="col-12 my-4 p-3 border bg-white rounded single-post-200-comment-box ">
          <h3 class="comment-box-title" v-t="`post.single.comment_section_title`"></h3>
          <CommentArchive1 commentable_type="content" :commentable_id="content.id"/>
        </div>

      </template>
    </m-single-content-wrapper>
  </div>
</template>

<script>
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter.js";
import mSingleContentWrapper from "../../Wrappers/SingleContentWrapper";
import mCategoryPanel301 from "../../Category/Filter/FilterCategory301";
import mSinglePostRelated300 from "../../Post/RelatedPost/SinglePostRelated300";
import mA from "../../Tags/A";
import mIcon from "../../Icons/Icon";
import mHtmlToComponentWrapper from "../../Wrappers/HtmlToComponentWrapper";
import mImg from "../../Tags/Img";
import CommentArchive1 from "../../Comment/Archive/CommentArchive1.vue";
import {Cards} from "../Card/Cards";
import {processContent} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";

export default {
  name: "SinglePost200",
  components: {
    mSingleContentWrapper, mCategoryPanel301,
    mA, mIcon, mSinglePostRelated300, mHtmlToComponentWrapper, mImg, CommentArchive1
  },
  props: {
    contentLink: {
      default: null,
    },
    flatCategoriesShape: {
      default: false,
    },
    relatedPostCard: {
      options: Object.keys(Cards),
      default: 'mPostCard310'
    }
  },
  methods: {
    processContent,
    dateFormat(value) {
      return dateConverter(value, "/", false)
    },
    authorName(content) {
      return content.author == undefined ? '' : this.userPublicName(content.author)
    },
    getContentCategories(content) {
      let categories = content.category

      if (categories != undefined) {
        categories = categories.map(item => {
          return item.slug;
        })
        return categories
      }
      return null
    },
    dataReady(content) {

    }
  },
};


</script>

<style scoped>

.single-post-200 :deep(video) {
  height: auto;
  width: 100%;
  margin: auto;
  position: relative;
  display: block;
  padding: 0;
  overflow: hidden;
}


.title-content {
  font-size: 1.7rem;
  display: inline;
  background-image: linear-gradient(
      transparent 60%,
      var(--primary) 60%
  );
  background-size: 80% 100%;
  background-repeat: no-repeat;
  background-position: top center;
}

.single-post-200-image {
  border-radius: 18px 18px 0 0;
  height: 450px;
  object-fit: cover;
}

@media screen and (max-width: 756px) {
  .single-post-200-image {
    height: 250px;
  }
}


/* Container holding the image and the text */
.container {
  position: relative;
  text-align: center;
  color: white;
}


/* Bottom right text */
.bottom-right {
  position: absolute;
  bottom: 8px;
  right: 16px;
}

.content-box {
  border-radius: 18px;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
}

.single-post-200-comment-box {
  border-radius: 18px;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
}
</style>
